/**
 * Utilidades para trabajar con localStorage de forma segura
 */

export const storage = {
  /**
   * Obtiene un valor del localStorage
   */
  get: <T>(key: string): T | null => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error al leer ${key} del localStorage:`, error);
      return null;
    }
  },

  /**
   * Guarda un valor en el localStorage
   */
  set: <T>(key: string, value: T): void => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error al guardar ${key} en localStorage:`, error);
    }
  },

  /**
   * Elimina un valor del localStorage
   */
  remove: (key: string): void => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error al eliminar ${key} del localStorage:`, error);
    }
  },

  /**
   * Limpia todo el localStorage
   */
  clear: (): void => {
    try {
      window.localStorage.clear();
    } catch (error) {
      console.error('Error al limpiar localStorage:', error);
    }
  },
};
